"use strict";
// The magic happens here where iosRTC creates the same global variables as the browser
window.cordova.plugins.iosrtc.registerGlobals();

// Then, just use the same code as the browser
module.exports = require("./browser");
module.exports.type = "iosrtc";
